"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["fill"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PeractoLogo = function PeractoLogo(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#fff' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "peracto-logo",
    "data-testid": "peracto-logo"
  }, /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468.62 129.48"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M467.34,415.33v19.75a2.48,2.48,0,0,1-.65,1.71c-.35.39-11,8.89-14.55,11.76-1,.79-3.45.84-3.45-1.48v-62c0-8.62,2.19-14.8,5.27-19.44a35.06,35.06,0,0,1,29.31-15.8A34.46,34.46,0,0,1,507.75,360v.14a34.31,34.31,0,0,1,7.47,11.11,33.67,33.67,0,0,1,2.63,13.23,34.57,34.57,0,0,1-2.63,13.45,34.48,34.48,0,0,1-32,21.27A35.2,35.2,0,0,1,467.34,415.33Zm4.69-19.5a15.26,15.26,0,0,0,11.24,4.56,14.78,14.78,0,0,0,11.25-4.7,15.34,15.34,0,0,0,4.69-11.24,14.81,14.81,0,0,0-1.28-6.05,16.35,16.35,0,0,0-3.41-5,15.8,15.8,0,0,0-22.49,0,15.26,15.26,0,0,0-4.69,10.82v.71A15.74,15.74,0,0,0,472,395.83Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M560.12,348.45a36,36,0,0,1,36.15,36,32.59,32.59,0,0,1-.43,5.27,2.38,2.38,0,0,1-.85,1.56,2.47,2.47,0,0,1-1.57.57h-48.1a16.67,16.67,0,0,0,14.8,9.25,16.41,16.41,0,0,0,10.1-3.42,2.15,2.15,0,0,1,1.57-.56,3.12,3.12,0,0,1,1.71.71l10.39,10.39a3.27,3.27,0,0,1,.71,1.85,2.14,2.14,0,0,1-.86,1.7,34.81,34.81,0,0,1-10.88,6.55,35.85,35.85,0,0,1-12.74,2.28,35.12,35.12,0,0,1-18.07-4.84A36,36,0,0,1,529,402.59a36.22,36.22,0,0,1,0-36.14,36,36,0,0,1,13.1-13.17A35.11,35.11,0,0,1,560.12,348.45Zm14.8,28.74a15.45,15.45,0,0,0-6-6.76,16.74,16.74,0,0,0-17.57,0,15.6,15.6,0,0,0-6,6.76Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M637,369.37a10.66,10.66,0,0,0-2.84-.43,10.82,10.82,0,0,0-10.68,10.81V416.9a2.25,2.25,0,0,1-.64,1.56,2.07,2.07,0,0,1-1.63.71H607.36a1.93,1.93,0,0,1-1.49-.71,2.25,2.25,0,0,1-.64-1.56V352.43a2.47,2.47,0,0,1,.64-1.71,2,2,0,0,1,1.49-.71h13.81a2,2,0,0,1,1.56.64,2.91,2.91,0,0,1,.71,1.5,27,27,0,0,1,9.54-1.71,30.59,30.59,0,0,1,11.67,2.27,2.7,2.7,0,0,1,1.28,1.43,2.18,2.18,0,0,1-.14,1.71l-6.26,12.38a1.93,1.93,0,0,1-1.85,1.28A1.68,1.68,0,0,1,637,369.37Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M680.65,349.87a34.1,34.1,0,0,1,15.94,3.84v-1.56a2.19,2.19,0,0,1,2.28-2.28H713a2.43,2.43,0,0,1,1.7.64,2.1,2.1,0,0,1,.72,1.64V416.9a2.07,2.07,0,0,1-.72,1.63,2.43,2.43,0,0,1-1.7.64H698.87a2.21,2.21,0,0,1-1.64-.64,2.18,2.18,0,0,1-.64-1.63v-1.57a35.24,35.24,0,0,1-15.94,3.84,34.51,34.51,0,0,1-24.48-10.1v-.14a34.7,34.7,0,0,1-7.47-11.1,34.57,34.57,0,0,1,31.95-48Zm15.94,35v-.71a15.41,15.41,0,0,0-4.7-10.82,14.74,14.74,0,0,0-11.24-4.7,15.25,15.25,0,0,0-11.24,4.56,15.86,15.86,0,0,0-4.55,11.24,16,16,0,0,0,4.55,11.38,16.13,16.13,0,0,0,22.48,0v-.14A15.39,15.39,0,0,0,696.59,384.88Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M760.63,401.1a17.25,17.25,0,0,0,10.1-3.42,2.15,2.15,0,0,1,1.57-.56,1.87,1.87,0,0,1,1.56.71l10.53,10.53a2.3,2.3,0,0,1,.71,1.71,3.68,3.68,0,0,1-.85,1.85,36.66,36.66,0,0,1-23.62,8.68,36.05,36.05,0,0,1-36.15-36.15,35,35,0,0,1,4.84-18.07,36,36,0,0,1,13.16-13.1,35.53,35.53,0,0,1,18.15-4.83,36.51,36.51,0,0,1,23.62,8.68,3.64,3.64,0,0,1,.85,1.85,2.33,2.33,0,0,1-.71,1.71l-10.53,10.38a2.1,2.1,0,0,1-3.13.29,16.43,16.43,0,0,0-10.1-3.42q-7.7,0-12,4.91a17,17,0,0,0-4.34,11.6,17.28,17.28,0,0,0,4.27,11.74Q752.81,401.1,760.63,401.1Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M841.1,417.32a2,2,0,0,1-1.35.86,34.13,34.13,0,0,1-8.25,1,29,29,0,0,1-15-4,28.63,28.63,0,0,1-10.67-11.1,33.1,33.1,0,0,1-3.91-16.22V373.63h-6a2.09,2.09,0,0,1-1.64-.71,2.43,2.43,0,0,1-.64-1.7V356.84a2.47,2.47,0,0,1,.64-1.71,2.12,2.12,0,0,1,1.64-.71h6V322a2.42,2.42,0,0,1,2.41-2.42h14.38a2.42,2.42,0,0,1,2.42,2.42v32.44h11.95a2.42,2.42,0,0,1,2.42,2.42v14.38a2.42,2.42,0,0,1-2.42,2.41H821.11v14.24q0,12.09,11.81,12.09a26,26,0,0,0,5.83-.71h.57a2,2,0,0,1,1.43.57,2.07,2.07,0,0,1,.85,1.85V415.9A2.45,2.45,0,0,1,841.1,417.32Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M881.16,348.45a36,36,0,0,1,33.37,22.05,35.42,35.42,0,0,1,2.78,13.95,35.9,35.9,0,0,1-2.78,14,34.17,34.17,0,0,1-7.75,11.45v.15a36.14,36.14,0,0,1-25.62,10.53,35.42,35.42,0,0,1-13.95-2.78,36,36,0,0,1-22.05-33.37,35.41,35.41,0,0,1,2.77-13.95,36.07,36.07,0,0,1,19.36-19.28A35.48,35.48,0,0,1,881.16,348.45ZM893,372.78a16.6,16.6,0,0,0-23.48,23.48A16.6,16.6,0,0,0,893,372.78Z",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M683,448.55",
    transform: "translate(-448.69 -319.56)",
    fill: fill
  })));
};

var _default = PeractoLogo;
exports["default"] = _default;